import { useAllSearchParams } from 'storfox-route-hooks'
import { sprintf } from 'sprintf-js'
import { useDetail, useLimitedCountList, useUpdate } from 'storfox-api-hooks'

import { queryToParams } from '~/utils'
import * as API from '~/constants/api-retailer'

import { ListingFilterSerializer } from '../serializers/index'

export const useListingList = () => {
  const searchParams = useAllSearchParams()
  const params = queryToParams(ListingFilterSerializer, searchParams, 'guid')
  const { getList, ...state } = useLimitedCountList(API.LISTING_LIST, params)
  return { ...state, getList: () => getList(params) }
}

export const useListingPublish = () => {
  return useUpdate(API.LISTING_PUBLISH)
}

export const useListingUnpublish = () => {
  return useUpdate(API.LISTING_UNPUBLISH)
}

export const useListingPause = () => {
  return useUpdate(API.LISTING_PAUSE)
}

export const useListingDetail = guid => {
  const url = sprintf(API.LISTING_PRODUCT_DETAIL, guid)
  return useDetail(url)
}

export const useListingUpdate = guid => {
  const url = sprintf(API.LISTING_PRODUCT_UPDATE, guid)
  return useUpdate(url)
}

export const useListingReject = () => {
  return useUpdate(API.LISTING_REJECT)
}
